import { api } from '../../core/network/api';

export interface TutorialState { step: number; completed: boolean; maxStep: number }
export interface TutorialReward { cash: number; xp: number; level: number; leveledUp: boolean }
export interface TutorialFinish { completed: boolean; alreadyDone: boolean; reward: TutorialReward | null }

export const fetchTutorial = () => api.get<TutorialState>('/tutorial');
export const saveTutorialStep = (step: number) => api.post<{ step: number }>('/tutorial/progress', { step });
export const completeTutorial = () => api.post<TutorialFinish>('/tutorial/complete', {});
export const skipTutorial = () => api.post<TutorialFinish>('/tutorial/skip', {});
